import React, { useState } from 'react';
import { 
  Leaf, Activity, Target, Apple, Droplets, Heart, 
  Zap, Sparkles, Waves, Hand, Flower2, UserCheck,
  Crown, Coins, Info, X, Check, Star, Gift
} from 'lucide-react';

const RedeemTab = ({ 
  userData, 
  subscriptionInfo, 
  setSelectedReward, 
  setShowRedeemModal, 
  setShowMediCoinModal,
  handleCardClick,
  onNavigate 
}) => {
  // State for discount popup
  const [showDiscountPopup, setShowDiscountPopup] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  
  // State for partnership program popup
  const [showPartnershipPopup, setShowPartnershipPopup] = useState(false);

  // Service data with member discount tiers
  const healthcareServices = [
    {
      id: 'naturopathic',
      name: 'Naturopathic Consultation',
      subtitle: 'Licensed AANP Doctor',
      description: 'Comprehensive natural health assessment and personalized treatment plan',
      icon: Leaf,
      gradient: 'from-green-500 to-emerald-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'chiropractic',
      name: 'Chiropractic Session',
      subtitle: 'ACA Certified',
      description: 'Spinal adjustments and rehabilitation therapy for musculoskeletal health',
      icon: Activity,
      gradient: 'from-blue-500 to-cyan-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'acupuncture',
      name: 'Acupuncture Treatment',
      subtitle: 'AAAOM Licensed',
      description: 'Traditional Chinese medicine with acupuncture and herbal treatments',
      icon: Target,
      gradient: 'from-yellow-500 to-orange-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'nutrition',
      name: 'Nutrition Consultation',
      subtitle: 'NANP Professional',
      description: 'Personalized nutrition plans emphasizing holistic wellness',
      icon: Apple,
      gradient: 'from-purple-500 to-pink-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'homeopathic',
      name: 'Homeopathic Consultation',
      subtitle: 'NCH Certified',
      description: 'Gentle, individualized natural medicine treatments',
      icon: Droplets,
      gradient: 'from-teal-500 to-green-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'yoga-therapy',
      name: 'Yoga Therapy Session',
      subtitle: 'IAYT Certified',
      description: 'Therapeutic yoga for chronic pain, anxiety, and stress management',
      icon: Heart,
      gradient: 'from-indigo-500 to-purple-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'reflexology',
      name: 'Reflexology Treatment',
      subtitle: 'RAA Certified',
      description: 'Non-invasive pressure-point therapy for overall wellness',
      icon: Zap,
      gradient: 'from-pink-500 to-rose-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'energy-healing',
      name: 'Energy Healing Session',
      subtitle: 'ACEP Certified',
      description: 'Reiki, EFT, and energy-based healing practices',
      icon: Sparkles,
      gradient: 'from-violet-500 to-purple-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'balneotherapy',
      name: 'Balneotherapy Treatment',
      subtitle: 'IAB Specialist',
      description: 'Mineral water treatments and hydrotherapy sessions',
      icon: Waves,
      gradient: 'from-cyan-500 to-blue-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'massage',
      name: 'Therapeutic Massage',
      subtitle: 'Licensed Therapist',
      description: 'Professional massage therapy for muscle tension and relaxation',
      icon: Hand,
      gradient: 'from-emerald-500 to-teal-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'aromatherapy',
      name: 'Aromatherapy Session',
      subtitle: 'Certified Practitioner',
      description: 'Essential oil therapy for stress relief and emotional balance',
      icon: Flower2,
      gradient: 'from-amber-500 to-orange-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    },
    {
      id: 'wellness-coaching',
      name: 'Wellness Coaching',
      subtitle: 'Certified Coach',
      description: 'Personal wellness coaching for lifestyle and behavioral changes',
      icon: UserCheck,
      gradient: 'from-red-500 to-pink-500',
      cost: 30000,
      discountRange: 'Up to 30% OFF',
      memberDiscounts: {
        Standard: '5-10% OFF',
        Silver: '10-15% OFF', 
        Gold: '15-25% OFF',
        Platinum: '20-30% OFF'
      }
    }
  ];

  const handleServiceClick = (service) => {
    setSelectedService(service);
    setShowDiscountPopup(true);
  };

  const handleRedeemClick = (e, service) => {
    e.stopPropagation();
    setSelectedReward({
      name: service.name,
      cost: service.cost,
      type: 'healthcare_service'
    });
    setShowRedeemModal(true);
  };
  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="p-6 text-white bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="mb-2 text-2xl font-bold">Rewards Marketplace</h3>
            <p className="opacity-90">
              Redeem your Medi Points for exclusive rewards and member discounts
            </p>
            <div className="flex items-center mt-4 space-x-6">
              <div>
                <p className="text-sm opacity-80">Your Balance</p>
                <p className="text-3xl font-bold">{userData.points.toLocaleString()}</p>
              </div>
              <div className="w-px h-12 bg-white/30"></div>
              <div>
                <p className="text-sm opacity-80">Membership</p>
                <div className="flex items-center space-x-2">
                  <Crown className="w-5 h-5" />
                  <p className="text-xl font-semibold">{subscriptionInfo?.tier || 'Gold'}</p>
                </div>
              </div>
              <div className="w-px h-12 bg-white/30"></div>
              <div>
                <p className="text-sm opacity-80">Your Discount</p>
                <p className="text-xl font-semibold">
                  {subscriptionInfo?.tier === 'Platinum' ? '20-30%' : 
                   subscriptionInfo?.tier === 'Gold' ? '15-25%' : 
                   subscriptionInfo?.tier === 'Silver' ? '10-15%' : '5-10%'} OFF
                </p>
              </div>
            </div>
          </div>
          <div className="text-right">
            <button
              onClick={() => setShowMediCoinModal(true)}
              className="flex items-center px-4 py-2 space-x-2 transition-all rounded-lg bg-white/20 backdrop-blur-sm hover:bg-white/30"
            >
              <Coins className="w-5 h-5" />
              <span>MediCoin Benefits</span>
            </button>
          </div>
        </div>
      </div>

      {/* Redemption Requirements Notice */}
      <div className="p-4 border border-purple-200 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl">
        <div className="flex items-start space-x-3">
          <Info className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="mb-2 font-semibold text-gray-900">Partner Network & Member Benefits</h4>
            <p className="mb-3 text-sm text-gray-600">
              🤝 <strong>Building partnerships for you!</strong> We're actively negotiating with healthcare providers to secure up to 30% discounts for our members.
            </p>
            <div className="p-3 mb-3 border border-blue-200 rounded-lg bg-blue-50">
              <p className="text-sm font-medium text-blue-800">
                🗺️ <strong>Coming Soon:</strong> Provider search by location with radius filtering
              </p>
              <p className="mt-1 text-xs text-blue-600">
                Find healthcare providers near you and book appointments with member discounts applied
              </p>
            </div>
            <p className="text-sm text-gray-600">
              💡 <strong>Get Started:</strong> Earn 30,000 MediPoints to unlock access to our growing partner network!
            </p>
          </div>
        </div>
      </div>

      {/* Healthcare Services Grid - 5 cards per row for scalability */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
        {healthcareServices.map((service) => {
          const IconComponent = service.icon;
          return (
            <div 
              key={service.id}
              className="overflow-hidden transition-all transform bg-white shadow-sm cursor-pointer rounded-xl hover:shadow-lg hover:scale-105"
              onClick={() => handleServiceClick(service)}
            >
              <div className={`p-4 text-white bg-gradient-to-r ${service.gradient}`}>
                <div className="flex items-center space-x-3">
                  <div className="p-2 rounded-lg bg-white/20 backdrop-blur-sm">
                    <IconComponent className="w-8 h-8" />
                  </div>
                  <div>
                    <h4 className="font-bold">{service.name}</h4>
                    <p className="text-xs opacity-90">{service.subtitle}</p>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="mb-4 text-sm text-gray-600">
                  {service.description}
                </p>
                
                {/* Member Discount Badge */}
                <div className="mb-4">
                  <div className="p-3 border border-blue-200 rounded-lg bg-gradient-to-r from-blue-50 to-purple-50">
                    <p className="text-sm font-medium text-center text-blue-700">
                      🤝 <strong>{service.discountRange}</strong>
                    </p>
                    <p className="mt-1 text-xs text-center text-gray-600">
                      Partnering with local providers near you
                    </p>
                  </div>
                </div>
                
                <div className="flex items-center justify-between pt-4 border-t">
                  <div>
                    <p className="text-2xl font-bold text-purple-600">{service.cost.toLocaleString()}</p>
                    <p className="text-xs text-gray-500">Medi Points</p>
                  </div>
                  <button
                    onClick={(e) => handleRedeemClick(e, service)}
                    disabled={userData.points < service.cost}
                    className={`px-4 py-2 rounded-lg font-medium transition-all ${
                      userData.points >= service.cost
                        ? 'bg-purple-600 text-white hover:bg-purple-700'
                        : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                    }`}
                  >
                    {userData.points >= service.cost ? 'Redeem' : 'Insufficient'}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Member Discount Popup */}
      {showDiscountPopup && selectedService && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-4xl p-6 bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto">
            {/* Popup Header */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-4">
                <div className={`p-3 rounded-xl bg-gradient-to-r ${selectedService.gradient}`}>
                  <selectedService.icon className="w-8 h-8 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">{selectedService.name}</h3>
                  <p className="text-gray-600">{selectedService.subtitle}</p>
                </div>
              </div>
              <button
                onClick={() => setShowDiscountPopup(false)}
                className="p-2 transition-all rounded-full hover:bg-gray-100"
              >
                <X className="w-6 h-6 text-gray-500" />
              </button>
            </div>

            {/* Service Description */}
            <div className="p-4 mb-6 border border-gray-200 rounded-xl bg-gray-50">
              <p className="text-gray-700">{selectedService.description}</p>
            </div>

            {/* Membership Tier Discounts */}
            <div className="mb-6">
              <h4 className="mb-4 text-xl font-semibold text-gray-900">Your Member Discount Benefits</h4>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                {Object.entries(selectedService.memberDiscounts).map(([tier, discount]) => {
                  const isCurrentTier = (subscriptionInfo?.tier || 'Gold') === tier;
                  return (
                    <div
                      key={tier}
                      className={`p-4 rounded-xl border-2 transition-all ${
                        isCurrentTier
                          ? 'border-purple-500 bg-gradient-to-br from-purple-50 to-pink-50 shadow-lg scale-105'
                          : 'border-gray-200 bg-white hover:border-gray-300'
                      }`}
                    >
                      <div className="flex items-center justify-between mb-2">
                        <h5 className={`font-bold ${isCurrentTier ? 'text-purple-700' : 'text-gray-700'}`}>
                          {tier}
                        </h5>
                        {isCurrentTier && (
                          <div className="px-2 py-1 text-xs font-medium text-purple-700 bg-purple-200 rounded-full">
                            Your Tier
                          </div>
                        )}
                      </div>
                      <div className="space-y-2">
                        <div className={`text-2xl font-bold ${
                          isCurrentTier ? 'text-purple-600' : 'text-gray-900'
                        }`}>
                          {discount}
                        </div>
                        <div className="text-sm text-gray-600">
                          <div className={`font-semibold ${
                            isCurrentTier ? 'text-purple-700' : 'text-green-600'
                          }`}>
                            Member Exclusive
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Member Benefits */}
            <div className="mb-6">
              <h4 className="mb-4 text-xl font-semibold text-gray-900">Why Choose MediCureOn</h4>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <div className="p-3 border border-green-200 rounded-lg bg-green-50">
                  <div className="flex items-center space-x-2">
                    <Check className="w-5 h-5 text-green-600" />
                    <p className="text-sm font-medium text-green-800">Verified Healthcare Providers</p>
                  </div>
                </div>
                <div className="p-3 border border-blue-200 rounded-lg bg-blue-50">
                  <div className="flex items-center space-x-2">
                    <Star className="w-5 h-5 text-blue-600" />
                    <p className="text-sm font-medium text-blue-800">Quality-Focused Network</p>
                  </div>
                </div>
                <div className="p-3 border border-purple-200 rounded-lg bg-purple-50">
                  <div className="flex items-center space-x-2">
                    <Gift className="w-5 h-5 text-purple-600" />
                    <p className="text-sm font-medium text-purple-800">Exclusive Member Pricing</p>
                  </div>
                </div>
                <div className="p-3 border border-yellow-200 rounded-lg bg-yellow-50">
                  <div className="flex items-center space-x-2">
                    <Crown className="w-5 h-5 text-yellow-600" />
                    <p className="text-sm font-medium text-yellow-800">Premium Healthcare Access</p>
                  </div>
                </div>
              </div>
            </div>

            {/* How It Works */}
            <div className="p-4 border border-blue-200 rounded-xl bg-blue-50">
              <div className="flex items-start space-x-3">
                <Info className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-blue-900">How Member Discounts Work</h4>
                  <ul className="mt-2 space-y-1 text-sm text-blue-800">
                    <li>• Redeem <strong>{selectedService.cost.toLocaleString()} MediPoints</strong> to access this service category</li>
                    <li>• Get your <strong>{subscriptionInfo?.tier || 'Gold'} member discount</strong> automatically applied</li>
                    <li>• Find quality providers in our growing network</li>
                    <li>• Book appointments with transparent, discounted pricing</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex gap-4 mt-6">
              <button
                onClick={() => {
                  handleRedeemClick({ stopPropagation: () => {} }, selectedService);
                  setShowDiscountPopup(false);
                }}
                disabled={userData.points < selectedService.cost}
                className={`flex-1 px-6 py-3 rounded-lg font-semibold transition-all ${
                  userData.points >= selectedService.cost
                    ? 'bg-purple-600 text-white hover:bg-purple-700'
                    : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                }`}
              >
                {userData.points >= selectedService.cost 
                  ? `Redeem for ${selectedService.cost.toLocaleString()} Points` 
                  : 'Insufficient Points'
                }
              </button>
              <button
                onClick={() => setShowDiscountPopup(false)}
                className="px-6 py-3 text-gray-700 transition-all border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Partnership Program Popup */}
      {showPartnershipPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-5xl p-8 bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto">
            {/* Popup Header */}
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center space-x-4">
                <div className="p-4 rounded-xl bg-gradient-to-br from-green-500 to-emerald-600">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-gray-900">Partnership Program</h3>
                  <p className="text-lg text-green-600 font-medium">Empowering Small to Medium Healthcare Businesses</p>
                </div>
              </div>
              <button
                onClick={() => setShowPartnershipPopup(false)}
                className="p-2 transition-all rounded-full hover:bg-gray-100"
              >
                <X className="w-6 h-6 text-gray-500" />
              </button>
            </div>

            {/* Mission Statement */}
            <div className="p-6 mb-8 border border-green-200 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl">
              <h4 className="mb-3 text-xl font-bold text-green-800">Our Mission: Building a Global Healthcare Movement</h4>
              <p className="text-green-700 text-lg leading-relaxed">
                MediCureOn is revolutionizing healthcare by connecting millions of wellness-focused Medicurians with quality healthcare providers worldwide. 
                We're building the largest global network that prioritizes member health outcomes while empowering healthcare businesses to scale and thrive.
              </p>
            </div>

            {/* Key Benefits for Providers */}
            <div className="mb-8">
              <h4 className="mb-6 text-2xl font-bold text-gray-900">Why Partner with MediCureOn?</h4>
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                <div className="p-6 border border-blue-200 bg-blue-50 rounded-xl">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="p-2 bg-blue-500 rounded-lg">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                      </svg>
                    </div>
                    <h5 className="text-lg font-bold text-blue-800">Expand Patient Base</h5>
                  </div>
                  <p className="text-blue-700">
                    Access our rapidly expanding global community of millions of health-conscious Medicurians actively seeking quality healthcare services.
                  </p>
                </div>

                <div className="p-6 border border-purple-200 bg-purple-50 rounded-xl">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="p-2 bg-purple-500 rounded-lg">
                      <Crown className="w-6 h-6 text-white" />
                    </div>
                    <h5 className="text-lg font-bold text-purple-800">Global Premium Network</h5>
                  </div>
                  <p className="text-purple-700">
                    Join an exclusive worldwide network of verified, quality-focused healthcare providers committed to excellence across 195+ markets.
                  </p>
                </div>

                <div className="p-6 border border-yellow-200 bg-yellow-50 rounded-xl">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="p-2 bg-yellow-500 rounded-lg">
                      <Coins className="w-6 h-6 text-white" />
                    </div>
                    <h5 className="text-lg font-bold text-yellow-800">Predictable Revenue</h5>
                  </div>
                  <p className="text-yellow-700">
                    Benefit from consistent member flow and transparent pricing structures that support your business growth as we scale globally.
                  </p>
                </div>

                <div className="p-6 border border-green-200 bg-green-50 rounded-xl">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="p-2 bg-green-500 rounded-lg">
                      <Target className="w-6 h-6 text-white" />
                    </div>
                    <h5 className="text-lg font-bold text-green-800">Targeted Marketing</h5>
                  </div>
                  <p className="text-green-700">
                    Reach millions of Medicurians who are already invested in their health journey and actively seeking your services.
                  </p>
                </div>
              </div>
            </div>

            {/* Member Health Focus */}
            <div className="mb-8">
              <h4 className="mb-6 text-2xl font-bold text-gray-900">Our Medicurians' Health Journey</h4>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                <div className="p-4 border border-teal-200 bg-teal-50 rounded-lg">
                  <div className="flex items-center space-x-2 mb-2">
                    <Activity className="w-5 h-5 text-teal-600" />
                    <h5 className="font-semibold text-teal-800">Active Wellness Tracking</h5>
                  </div>
                  <p className="text-sm text-teal-700">
                    Medicurians actively monitor steps, heart rate, sleep, and nutrition through our comprehensive wellness platform.
                  </p>
                </div>

                <div className="p-4 border border-pink-200 bg-pink-50 rounded-lg">
                  <div className="flex items-center space-x-2 mb-2">
                    <Heart className="w-5 h-5 text-pink-600" />
                    <h5 className="font-semibold text-pink-800">Preventive Care Focus</h5>
                  </div>
                  <p className="text-sm text-pink-700">
                    Our community prioritizes preventive healthcare and early intervention for optimal health outcomes.
                  </p>
                </div>

                <div className="p-4 border border-indigo-200 bg-indigo-50 rounded-lg">
                  <div className="flex items-center space-x-2 mb-2">
                    <Sparkles className="w-5 h-5 text-indigo-600" />
                    <h5 className="font-semibold text-indigo-800">Holistic Approach</h5>
                  </div>
                  <p className="text-sm text-indigo-700">
                    Medicurians seek integrated healthcare combining traditional and alternative therapies for complete wellness.
                  </p>
                </div>
              </div>
            </div>

            {/* Partnership Process */}
            <div className="mb-8">
              <h4 className="mb-6 text-2xl font-bold text-gray-900">Simple Partnership Process</h4>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 text-white bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-lg font-bold">1</span>
                  </div>
                  <h5 className="font-semibold text-gray-800 mb-2">Apply</h5>
                  <p className="text-sm text-gray-600">Submit your practice information and credentials</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 text-white bg-blue-500 rounded-full flex items-center justify-center">
                    <span className="text-lg font-bold">2</span>
                  </div>
                  <h5 className="font-semibold text-gray-800 mb-2">Review</h5>
                  <p className="text-sm text-gray-600">Our team verifies your qualifications and practice quality</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 text-white bg-purple-500 rounded-full flex items-center justify-center">
                    <span className="text-lg font-bold">3</span>
                  </div>
                  <h5 className="font-semibold text-gray-800 mb-2">Setup</h5>
                  <p className="text-sm text-gray-600">Configure your services and pricing in our platform</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 text-white bg-emerald-500 rounded-full flex items-center justify-center">
                    <span className="text-lg font-bold">4</span>
                  </div>
                  <h5 className="font-semibold text-gray-800 mb-2">Launch</h5>
                  <p className="text-sm text-gray-600">Start receiving qualified Medicurian referrals</p>
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="p-6 border border-green-300 bg-gradient-to-r from-green-100 to-emerald-100 rounded-xl">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="text-xl font-bold text-green-800 mb-2">Ready to Transform Your Practice?</h4>
                  <p className="text-green-700 mb-4">
                    Join the MediCureOn global movement and connect with millions of health-conscious Medicurians who value quality care.
                  </p>
                  <div className="flex items-center space-x-2 text-green-800">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <span className="font-semibold">partners@medicureon.com</span>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-green-600 mb-1">50M+</div>
                  <div className="text-sm font-medium text-green-700">Projected Medicurians</div>
                  <div className="text-xs text-green-600 mb-2">(by 2027)</div>
                  <div className="text-2xl font-bold text-green-600 mb-1">195+</div>
                  <div className="text-sm font-medium text-green-700">Global Markets</div>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex gap-4 mt-8">
              <button
                onClick={() => {
                  window.open('mailto:partners@medicureon.com?subject=Healthcare%20Provider%20Partnership%20Inquiry&body=Hello%20MediCureOn%20Team,%0A%0AI%20am%20interested%20in%20joining%20your%20healthcare%20provider%20network.%0A%0APractice%20Name:%20%0ALocation:%20%0ASpecialty:%20%0AContact%20Phone:%20%0A%0APlease%20send%20me%20more%20information%20about%20partnership%20opportunities.%0A%0AThank%20you!', '_blank');
                  setShowPartnershipPopup(false);
                }}
                className="flex-1 px-8 py-4 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg font-semibold text-lg hover:from-green-700 hover:to-emerald-700 transition-all shadow-lg"
              >
                🤝 Apply to Partner Network
              </button>
              <button
                onClick={() => setShowPartnershipPopup(false)}
                className="px-8 py-4 text-gray-700 transition-all border border-gray-300 rounded-lg hover:bg-gray-50 font-semibold"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Healthcare Provider Network Invitation */}
      <div className="p-6 mt-8 border border-green-200 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0 p-2 bg-green-100 rounded-full">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m0 0h2M9 7h6m-6 4h6m-6 4h3" />
            </svg>
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-gray-900">Healthcare Providers - Join Our Network!</h4>
            <p className="mt-1 text-sm text-gray-600">
              Are you a healthcare practitioner looking to expand your patient base? Partner with MediCureOn to offer exclusive discounts to our wellness-focused community.
            </p>
            <p className="mt-2 text-sm text-green-700 font-medium">
              ✉️ Contact us at: <span className="font-mono bg-white px-2 py-1 rounded border">partners@medicureon.com</span>
            </p>
            <div className="flex gap-3 mt-4">
              <button
                onClick={() => window.open('mailto:partners@medicureon.com?subject=Healthcare%20Provider%20Partnership%20Inquiry&body=Hello%20MediCureOn%20Team,%0A%0AI%20am%20interested%20in%20joining%20your%20healthcare%20provider%20network.%0A%0APractice%20Name:%20%0ALocation:%20%0ASpecialty:%20%0AContact%20Phone:%20%0A%0APlease%20send%20me%20more%20information%20about%20partnership%20opportunities.%0A%0AThank%20you!', '_blank')}
                className="px-6 py-2 text-white transition-all bg-green-600 rounded-lg hover:bg-green-700 font-medium"
              >
                🤝 Join Network
              </button>
              <button
                onClick={() => setShowPartnershipPopup(true)}
                className="px-6 py-2 text-green-700 transition-all border border-green-300 rounded-lg hover:bg-green-100 font-medium"
              >
                📋 Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedeemTab;
